export default __webpack_public_path__ + "static/media/482.09d93d18.png";